import * as React from "react";
import { Field } from "react-final-form";

import { ITeam } from "store/entities/teams";

import { AgentTeams } from "../agent-teams";

import { AgentFormSection } from "./AgentFormSection";
import { AgentFormSectionId } from "./constants";

interface IProps {
  teams: ITeam[];
  canManageAgentTeams: boolean;
}

export const TeamMembershipManagement: React.FC<IProps> = ({ teams, canManageAgentTeams }) => (
  <AgentFormSection header={{ id: AgentFormSectionId.TeamsManagement, component: "Member of the following Teams" }}>
    <Field
      name="teamIds"
      render={({ input }) => (
        <AgentTeams
          key={input.name}
          teams={teams}
          canManageAgentTeams={canManageAgentTeams}
          value={input.value}
          onChange={input.onChange}
        />
      )}
    />
  </AgentFormSection>
);
